module.exports = __webpack_public_path__ + "img/header-diamondJewelryBracelets.26854cf.webp";